import { DateRangePreset, getPresetRange, isCustomPreset } from './date-range-presets';

/**
 * Value shape used by the date range filter (preset id + optional from/to for custom presets).
 * Compatible with DateRangeFilterValue from parseAsDateRangeFilter.
 */
export interface DateRangeFilterValueLike {
  preset: DateRangePreset;
  from?: string;
  to?: string;
}

export interface DateRangeFilterValueToRangeOptions {
  /** Timezone used to resolve preset ranges (e.g. start/end of day). Defaults to 'UTC'. */
  timezone?: string;
}

/**
 * Parses a date range filter value into from/to ISO date strings.
 * For presets, resolves the preset in the given timezone; for custom presets uses from/to from the value.
 * Returns an object with from/to (or undefined when value is null or range cannot be resolved).
 */
export function dateRangeFilterValueToRange(
  value: DateRangeFilterValueLike | null,
  options: DateRangeFilterValueToRangeOptions = {},
): { from?: string; to?: string } {
  if (value == null) return {};

  const timezone = options.timezone ?? 'UTC';

  if (isCustomPreset(value.preset)) {
    return { from: value.from, to: value.to };
  }

  const range = getPresetRange(value.preset, timezone);
  if (!range) return {};

  return {
    from: range.from.toISOString(),
    to: range.to.toISOString(),
  };
}
